import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
    isPrinting = false;
    constructor(private router: Router, private activatedRoute: ActivatedRoute) { }
  //printDocument(documentName: string, num: Number) {
  //  alert("print: " + num);
  //  this.isPrinting = true;
  //  this.router.navigate(['/',
  //    {
  //      outlets: {
  //        'print': ['print', documentName ]
  //      }
  //    }]);
  //  }

    printDocument(documentName: string, num: any) {
        //alert("print: " + num);
        this.isPrinting = true;
        this.router.navigate(['/',
            {
                outlets: {
                    'print': ['print', documentName, num]
                }
          }]);

      //this.router.navigate(['/',
      //  {
      //    outlets: {
      //      'printIDL': ['printIDL', documentName, num]
      //    }
      //  }]);
        //this.router.navigate([{ outlets: { print: [documentName, num ] } }]);
        //this.router.navigate(['print/' + documentName, num //'/',
        //    //{
        //    //    outlets: {
        //    //        print: ['print/' + documentName, num]
        //    //    }
        //    //}
        //]
        //    //,
        //    //{
        //    //    relativeTo: this.activatedRoute
        //    //}
        //);

            // this.router.navigate(['/',
            //{
            //    outlets: {
            //        'print': ['print',  documentName, num]
            //    }
            //}]);

       // this.router.navigate(['print/' + documentName, num]);//,
            //{
            //    relativeTo: this.activatedRoute // <--- PARENT activated route.
            //});
        //this.router.navigate(['/',
        //    {
        //        outlets: {
        //            'print': ['print', documentName, num]
        //        }
        //    }]
        //    ,
        //    {
        //        relativeTo: this.activatedRoute
        //    }
           
        //);

        //this.router.navigate(['/',
        //    {
        //        outlets: {
        //            'print': ['print', documentName, num]
        //        }
        //    }]);
  }
  FormattedCode: string;
  printDocument2(documentName: string, num: any) {
    this.FormattedCode = documentName;
   // this.GetCode();
  }
  public GetCode(): string {
    return this.FormattedCode;
  }
  BillNumber: string;
  printDocument3(documentName: string, num: any) {
    this.BillNumber = documentName;
    // this.GetCode();
  }
  public GetBillNumber(): string {
    return this.BillNumber;
  }
  ChargeEntryCode: any;
  printDocument4(documentName: string, num: any) {
    this.ChargeEntryCode = num;
    // this.GetCode();
  }
  public GetChargeEntryCode(): string {
    return this.ChargeEntryCode;
  }
    //printDocument(documentName: string, documentData: string[]) {
    //    this.isPrinting = true;
    //    this.router.navigate(['/',
    //        {
    //            outlets: {
    //                'print': ['print', documentName, documentData.join()]
    //            }
    //        }]);
    //}
    onDataReady() {
        //alert("ready to print..");
    //setTimeout(() => {
      window.print();
      this.isPrinting = false;
      this.router.navigate([{ outlets: { print: null } }]);
    //});
  }

}
